var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChangeLanguage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#4b4495;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "list_alt-24px",
    "data-name": "list alt-24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29400",
    "data-name": "Path 29400",
    className: "cls-1",
    d: "M0,0H24V24H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.73,4.31a.61.61,0,0,1,.6.6V19.09a.61.61,0,0,1-.6.6H4.27a.61.61,0,0,1-.6-.6V4.91a.61.61,0,0,1,.6-.6H19.73m0-2H4.27a2.61,2.61,0,0,0-2.6,2.6V19.09a2.61,2.61,0,0,0,2.6,2.6H19.73a2.61,2.61,0,0,0,2.6-2.6V4.91a2.61,2.61,0,0,0-2.6-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M7.24,7.43a.43.43,0,0,1,.2.33.36.36,0,0,1-.19.32H8.91v.65H7.65a1.52,1.52,0,0,1,.72.51,1.37,1.37,0,0,1,.24.82,1.44,1.44,0,0,1-.38,1,1.29,1.29,0,0,1-1,.42,1.32,1.32,0,0,1-1.06-.43,1.36,1.36,0,0,1-.36-.89,1.64,1.64,0,0,1,.25-.92,1.36,1.36,0,0,1,.72-.52H5.53V8.08H6.84A.39.39,0,0,0,7.11,8a.32.32,0,0,0,.13-.23.42.42,0,0,0-.16-.32H5.53V6.8H7.72a1.16,1.16,0,0,0,.73-.2A.79.79,0,0,0,8.7,6a.83.83,0,0,0-.41-.7h.16a1.12,1.12,0,0,1,.48,1,1.18,1.18,0,0,1-.34.87,1.24,1.24,0,0,1-.91.33Zm1,2.38A1.08,1.08,0,0,0,7.92,9a1,1,0,0,0-.75-.31.85.85,0,0,0-.72.34,1.06,1.06,0,0,0,0,1.4.92.92,0,0,0,.77.33,1,1,0,0,0,.72-.29A.94.94,0,0,0,8.21,9.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.85,18.55V13.93h2.81v.56H15.49v1.37h1.93v.54H15.49V18h2.34v.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13,16.75v1H9.11a2.39,2.39,0,0,1-2.38-2.39V14l-.42.4-.7-.72,1.48-1.43.07-.06.06-.07,1.62,1.56-.69.72L7.73,14v1.38a1.38,1.38,0,0,0,1.38,1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M17.87,11.73l-1.63,1.55-.06-.07-.08-.08-1.47-1.4.7-.73.42.4V9.93a1.38,1.38,0,0,0-1.38-1.38H10.45v-1h3.92a2.39,2.39,0,0,1,2.38,2.38V11.4l.42-.4Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLanguage);
export default __webpack_public_path__ + "static/media/Change Language.16f6e2954c088a30e0772b26780b47e5.svg";
export { ForwardRef as ReactComponent };